<template lang="pug">
  v-layout(align-start)
    v-flex
      v-data-table.elevation-1(:headers='headers' item-key='empleados' :items='empleados' :search='search' sort-by='nombre' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top)
          v-toolbar(flat color='primary' dark)
            v-toolbar-title Empleados
            v-divider.mx-4(inset vertical)
            v-spacer
            v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
            v-spacer
            v-btn.mx-2(v-if='validarCrear()' fab dark small color='success' @click='dialog = true' )
              v-icon(dark) mdi-plus
            EmpleadoM(:dialog='dialog' :editedIndex='editedIndex' @close='close' :read='read' :FormPadre='editedItem' @save='listarEmpleados' @edited='listarEmpleados')
        template(v-slot:item.action='{ item }')
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon(color='indigo' @click='editItem(item, true)' v-on="on") mdi-eye
            | Visualizar
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon.mr-2(v-if='validarModificar()' color='warning' @click='editItem(item, false)' v-on="on") mdi-pencil
            | Editar
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon(v-if='validarEliminar()' color='error' @click='deleteItem(item)' v-on="on") mdi-delete
            | Eliminar
        template(v-slot:no-data)
          h1 No hay empleados registrados
</template>

<script>
import Api from '@/services/methods'
import EmpleadoM from '@/components/modals/EmpleadoM'
// import ListadoVendedores from "../components/ListadoVendedores";
export default {
  data: () => ({
    dialog: false,
    read: false,
    selecEstado: '',
    selecMunicipio: '',
    selecParroquia: '',
    selectEmp: '',
    dialogShow: false,
    dialog1: false,
    dialog2: false,
    mostrar: false,
    mostrarPoRu: false,
    dateIngreso: new Date().toISOString().substr(0, 10),
    dateVacaciones: new Date().toISOString().substr(0, 10),
    modalIngreso: false,
    modalVacaciones: false,
    loading: true,
    headers: [
      { text: 'Cedula', align: 'center', value: 'cedula' },
      { text: 'Nombre', align: 'center', value: 'nombre' },
      { text: 'Apellido', align: 'center', value: 'apellido' },
      { text: 'Fecha de Ingreso', align: 'center', value: 'fechaIngreso' },
      { text: 'Tipo de Empleado', align: 'center', value: 'tipoEmpleado.descripcion' },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],
    estado: [],
    idEstadoArray: [],

    municipio: [],
    idMunicipioArray: [],

    parroquia: [],
    idParroquiaArray: [],

    arrayMunicipioEstado: [],
    arrayParroquiaMunicipio: [],

    portafolio: [],
    idPortafolioArray: [],

    ruta: [],
    idRutaArray: [],
    selecEmp: '',

    tipo: [],
    tipoArray: [],

    rifNumerico: '',
    rifLetra: '',

    search: '',
    permisosRuta: {},
    empleados: [],
    editedIndex: -1,
    editedItem: {
      cedula: '',
      rif: '',
      nombre: '',
      apellido: '',
      fechaIngreso: '',
      fechaVacaciones: '',
      codEstado: '',
      codMunicipio: '',
      codParroquia: '',
      direccion: '',
      telefono: '',
      tipoEmpleado: '',
      vendedor: []
    },

    items2: ['V', 'E'],

    defaultItem: {
      cedula: '',
      rif: '',
      nombre: '',
      apellido: '',
      fechaIngreso: '',
      fechaVacaciones: '',
      codEstado: '',
      codMunicipio: '',
      codParroquia: '',
      direccion: '',
      telefono: '',
      tipoEmpleado: '',
      vendedor: []
    },

    activator: null
  }),

  components: {
    EmpleadoM
  },

  //
  computed: {
  //   formTitle() {
  //     return this.editedIndex === -1
  //       ? "Nuevo Empelado"
  //       : this.read
  //       ? "Informacion del Empelado"
  //       : "Modificar Empleado";
  //   }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }

  },

  created () {
    this.initialize()
    // this.getTipoEmpleado();

    this.permisosRuta = this.$store.state.empresa[0].permisos.find(
      permiso => permiso.ruta === 'Empleado'
    )
  },

  methods: {
    // getTipoEmpleado() {
    //   Api.get("/tipoEmpleado")
    //     .then(response => {
    //       this.tipo = response.data;
    //       this.tipo.map(data => {
    //         this.tipoArray.push({
    //           text: data.descripcion,
    //           value: data._id
    //         });
    //       });
    //     })
    //     .catch(e => {
    //       console.log("error" + e);
    //     });
    // },

    // tipoSeleccionado(data) {
    //   const empleado = this.tipo.find(empleado => empleado._id == data);
    //   this.editedItem.tipoEmpleado = empleado;
    //   console.log(this.editedItem.tipoEmpleado);
    //   if (this.editedItem.tipoEmpleado.descripcion == "Supervisor") {
    //     console.log("paso Supervisor");
    //     this.mostrarPoRu = false;
    //     this.mostrar = true;
    //   } else if (this.editedItem.tipoEmpleado.descripcion == "Vendedor") {
    //     console.log("paso vendedor");
    //     this.mostrar = false;
    //     this.mostrarPoRu = true;
    //   } else {
    //     console.log("paso otro");
    //     console.log(data);
    //     this.mostrar = false;
    //     this.mostrarPoRu = false;
    //   }
    // },

    formato (fecha) {
      return this.$moment(fecha).format('YYYY-MM-DD')
    },

    // changeEstado(data) {
    //   console.log("Seleccionando estado");
    //   const es = this.estado.find(es => es._id == data);
    //   this.editedItem.idEstado = es;
    //   console.log(this.editedItem.idEstado)
    //   this.arrayMunicipioEstado = [];
    //   for (let i = 0; i < this.idMunicipioArray.length; i++) {
    //     if (data == this.idMunicipioArray[i].idEstado._id) {
    //       //Ciclo para llenar los estado
    //       this.arrayMunicipioEstado.push(this.idMunicipioArray[i]);
    //     }
    //   }
    // },
    // changeMunicipio(data) {
    //   console.log("Seleccionando Municipio");
    //   const mu = this.municipio.find(mu => mu._id == data);
    //   this.editedItem.idMunicipio = mu;
    //   console.log(this.editedItem.idMunicipio)
    //   this.arrayParroquiaMunicipio = [];
    //   for (let i = 0; i < this.idParroquiaArray.length; i++) {
    //     if (data == this.idParroquiaArray[i].idMunicipio._id) {
    //       //Ciclo para llenar los municipios
    //       this.arrayParroquiaMunicipio.push(this.idParroquiaArray[i]);
    //     }
    //   }
    // },
    // changeParroquia(data) {
    //   console.log("Seleccionando Municipio");
    //   const pa = this.parroquia.find(pa => pa._id == data);
    //   this.editedItem.idParroquia = pa;
    //   console.log(this.editedItem.idParroquia)
    // },
    // concatenarRif() {
    //   this.editedItem.rif = this.rifLetra + "-" + this.rifNumerico;
    // },
    // desconcatenarRif(rif) {
    //   this.rifLetra = rif.charAt(0);
    //   this.rifNumerico = rif.substr(2);
    // },
    initialize () {
      this.listarEmpleados()
      // this.listarEstados();
      // this.listarMunicipio();
      // this.listarParroquia();
      // this.listarPortafolios();
      // this.listarRutas();
      /* this.permisosRuta = this.$store.state.empresa[0].permisos.find(
                          permiso => permiso.ruta == "Empleado") */
    },

    validarCrear () {
      return this.permisosRuta?.accion.includes('Crear')
    },
    validarModificar () {
      return this.permisosRuta?.accion.includes('Modificar')
    },
    validarEliminar () {
      return this.permisosRuta?.accion.includes('Eliminar')
    },
    // listarPortafolios() {
    //   Api.get("/portafolio")
    //     .then(response => {
    //       this.portafolio = response.data;
    //       console.log("Portafolio");
    //       console.log(this.portafolio);
    //       this.portafolio.map(data => {
    //         this.idPortafolioArray.push({
    //           text: data.descripcion,
    //           value: data._id
    //         });
    //       });
    //     })
    //     .catch(e => {
    //       console.log("error" + e);
    //     });
    // },
    // listarRutas() {
    //   Api.get("/ruta")
    //     .then(response => {
    //       this.ruta = response.data;
    //       console.log("Ruta");
    //       console.log(this.ruta);
    //       this.ruta.map(data => {
    //         this.idRutaArray.push({
    //           text: data.nombre,
    //           value: data._id
    //         });
    //       });
    //     })
    //     .catch(e => {
    //       console.log("error" + e);
    //     });
    // },

    listarEmpleados () {
      Api.get('/empleado')
        .then(response => {
          this.empleados = response.data
          this.empleados.map(data => {
            data.fechaIngreso = this.formato(data.fechaIngreso)
            data.fechaVacaciones = this.formato(data.fechaVacaciones)
          })
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    // listarEstados() {
    //   Api.get("/estado")
    //     .then(response => {
    //       this.estado = response.data;
    //       console.log("Listando estados");
    //       console.log(this.estado);
    //       this.estado.map(data => {
    //         this.idEstadoArray.push({
    //           text: data.nombre,
    //           value: data._id
    //         });
    //       });
    //       console.log(this.idEstadoArray);
    //     })
    //     .catch(e => {
    //       console.log("error" + e);
    //     });
    // },
    // listarMunicipio() {
    //   Api.get("/municipio")
    //     .then(response => {
    //       this.municipio = response.data;
    //       console.log("Listando municipios");
    //       console.log(this.municipio);
    //       this.municipio.map(data => {
    //         this.idMunicipioArray.push({
    //           text: data.nombre,
    //           value: data._id,
    //           idEstado: data.idEstado
    //         });
    //       });
    //     })
    //     .catch(e => {
    //       console.log("error" + e);
    //     });
    // },
    // listarParroquia() {
    //   Api.get("/parroquia")
    //     .then(response => {
    //       this.parroquia = response.data;
    //       console.log("Listando parroquias");
    //       console.log(this.parroquia);
    //       this.parroquia.map(data => {
    //         this.idParroquiaArray.push({
    //           text: data.nombre,
    //           value: data._id,
    //           idMunicipio: data.idMunicipio
    //         });
    //       });
    //     })
    //     .catch(e => {
    //       console.log("error" + e);
    //     });
    // },
    editItem (item, bool) {
      this.editedIndex = this.empleados.indexOf(item)
      this.editedItem = Object.assign({}, item)
      // this.selecParroquia = this.editedItem.idParroquia._id;
      // this.selecEstado = this.editedItem.idEstado._id;
      // this.selecMunicipio = this.editedItem.idMunicipio._id;
      // this.desconcatenarRif(item.rif);
      this.dialog = true
      this.read = bool
    },

    deleteItem (item) {
      const index = this.empleados.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quiere borrar?',
        text: 'No podrá revertir',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          Api.put('/empleado/deletelog/' + item._id).then(response => {
            this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
            this.empleados.splice(index, 1)
          })
        }
      })
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        // this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1
        // this.ListadoVendedores = "";
        // this.rifNumerico = "";
        // this.rifLetra = "";
        // this.editedItem.rif = "";
        this.read = false
      }, 300)
    },
    // validarCampos() {
    //   if (
    //     this.editedItem.cedula == "" ||
    //     this.editedItem.rifLetra == "" ||
    //     this.editItem.rifNumerico == "" ||
    //     this.editedItem.nombre == "" ||
    //     this.editedItem.apellido == "" ||
    //     this.editedItem.direccion == "" ||
    //     this.editedItem.telefono == "" ||
    //     this.editedItem.fechaIngreso == "" ||
    //     this.editedItem.fechaVacaciones == "" ||
    //     this.editedItem.estado == "" ||
    //     this.editedItem.municipio == "" ||
    //     this.editedItem.parroquia == "" ||
    //     this.editedItem.tipoEmpleado == ""
    //   ) {
    //     this.$swal({
    //       icon: "error",
    //       title: "Formulario incompleto",
    //       text: "Por favor llene todos los campos para continuar"
    //     });
    //     return true;
    //   } else if (
    //     this.editedItem.cedula.length != 8 &&
    //     this.editedItem.cedula.length != 7
    //   ) {
    //     this.$swal({
    //       icon: "error",
    //       title: "Cedula invalida",
    //       text: "Por favor ingrese una cedula correcta"
    //     });
    //     return true;
    //   } else if (
    //     this.editedItem.nombre.length > 20 ||
    //     this.editedItem.apellido.length > 40
    //   ) {
    //     this.$swal({
    //       icon: "error",
    //       title: "Error!",
    //       text: "Ha excedido el limite de caracteres"
    //     });
    //     return true;
    //   } else if (this.editedItem.telefono.length != 15) {
    //     this.$swal({
    //       icon: "error",
    //       title: "Error!",
    //       text:
    //         "El campo de telefono debe tener 15 digitos, por favor verifique"
    //     });
    //     return true;
    //   } else if (
    //     this.editedItem.tipoEmpleado.descripcion == "Supervisor" &&
    //     this.editedItem.vendedor.length <= 0
    //   ) {
    //     this.$swal({
    //       icon: "error",
    //       title: "No existen vendedores cargados",
    //       text: "Carge vendedores para continuar"
    //     });
    //     return true;
    //   } else if (
    //     this.editedItem.fechaIngreso >= this.editedItem.fechaVacaciones
    //   ) {
    //     this.$swal({
    //       icon: "error",
    //       title: "Error en las fechas",
    //       text:
    //         "Fecha de ingreso no puede ser mayor o igual a Fecha de Vacaciones"
    //     });
    //     return true;
    //   } else if (
    //     this.rifNumerico.length < 7
    //   ) {
    //     this.$swal({
    //       icon: "error",
    //       title: "Rif invalido",
    //       text: "El rif debe tener entre 7 a 9 caracteres"
    //     });
    //     return true;
    //   }
    //   return false;
    // },
    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    }
    // save() {
    //   if (!this.validarCampos()) {
    //      this.concatenarRif();
    //     if (this.editedIndex > -1) {
    //       console.log("Datos guardados");
    //       Api.put("/empleado", this.editedItem)
    //         .then(response => {
    //           console.log(response);
    //           this.$swal({
    //             icon: "success",
    //             title: "Modificacion exitosa",
    //             text: "Todos los cambios han sido efectuados"
    //           });
    //         })
    //         .catch(e => {
    //           this.$swal({
    //             icon: "error",
    //             title: "Error al modificar",
    //             text: "Por favor, verifique los datos e intente de nuevo"
    //           });
    //         });

    //       Object.assign(this.empleados[this.editedIndex], this.editedItem);
    //     } else {
    //       Api.post("/empleado", this.editedItem)
    //         .then(response => {
    //           console.log(response);
    //           console.log(this.editedItem);
    //           this.editedItem._id = response.data._id;
    //           this.$swal({
    //             icon: "success",
    //             title: "Inclusion exitosa",
    //             text: "Todos los datos han sido guardados"
    //           });
    //           console.log(response.data);
    //           this.empleados.push(response.data);
    //         })
    //         .catch(e => {
    //           console.log("error" + e);
    //           this.$swal({
    //             icon: "error",
    //             title: "Error al guardar",
    //             text: "Por favor, verifique los datos e intente de nuevo"
    //           });
    //         });
    //     }
    //     console.log("Datos Guardados");
    //     this.listarEmpleados();
    //     this.close();
    //   }
    // }
  }
}
</script>
